var React = require('react');

function ChevronRightInline (props) {
    return React.createElement("svg",props,[React.createElement("title",{"id":"chevronRightIconTitle","key":0},"Chevron Right"),React.createElement("polyline",{"points":"10 6 16 12 10 18 10 18","key":1})]);
}

ChevronRightInline.defaultProps = {"role":"img","width":"48px","height":"48px","viewBox":"0 0 24 24","aria-labelledby":"chevronRightIconTitle","stroke":"#864bff","strokeWidth":"1","strokeLinecap":"square","strokeLinejoin":"miter","fill":"none","color":"#864bff"};

module.exports = ChevronRightInline;

ChevronRightInline.default = ChevronRightInline;
